import React from 'react';
import { connect } from 'react-redux';

const pic = (WrappedComponent, charType) => {
	class Pic extends React.Component {
		render() {
			let directionsStyle = {},
				imgStyle = {},
				captionStyle = {};
			if (this.props.char !== undefined) {
				if (charType === 'lc') {
					directionsStyle = {backgroundImage: 'url(./images/sections/lc/chars/directions/' + this.props.char + '.svg)'};
				}
				imgStyle = {backgroundImage: 'url(./images/sections/pic/' + this.props.char.toLowerCase() + '.jpg)'};
				captionStyle = {backgroundImage: 'url(./images/sections/' + charType + '/chars/captions/' + this.props.char + '.svg)'};
			}
			return (
				<div id={charType + '-pic'} className="char-pic panel">
			        <div className="directions" style={directionsStyle}></div>
			        <div className="holder">
			            <div className="holder-inner" style={imgStyle}></div>
			        </div>
			        <div className="caption" style={captionStyle}></div>
			    </div>
		  	);
		}
	};

	const mapStateToProps = function(state) {
		return {
			char: state.char.char
		}
	}

	return connect(mapStateToProps, undefined)(Pic);
}

export default pic;


// WEBPACK FOOTER //
// ./src/components/sections/shared/Pic.js